export const AYS_CODE_DRG_INEK_SECTION_COLORS = {
    'MEDICAL_SERVICE': '#e6194b',
    'NURSING_SERVICE': '#3cb44b',
    'MEDTECH_SERVICE': '#4363d8',
    'DRUGS_OVERHEAD': '#911eb4',
    'DRUGS_SINGLE': '#f032e6',
    'IMPLANTS': '#fabebe',
    'MEDICAL_SUPPLIES_OVERHEAD': '#e6beff',
    'MEDICAL_SUPPLIES_SINGLE': '#9a6324',
    'MEDICAL_SUPPLIES_EXTERNAL': '#800000',
    'INFRASTRUCTURE_MEDICAL': '#808000',
    'INFRASTRUCTURE_NON_MEDICAL': '#000075'
};

export const AYS_CODE_DRG_INEK_TOP_SECTION_COLORS = {
  'STAFF': '#e6194b',
  'DRUGS': '#f032e6',
  'IMPLANTS': '#fabebe',
  'MEDICAL_SUPPLIES': '#9a6324',
  'INFRASTRUCTURE': '#000075'
};

